import { all, takeEvery } from "redux-saga/effects";

import { sendRequest } from "../helpers";
import actionTypes from "./actionTypes";

export default function* saga() {
  yield all([takeEvery(actionTypes.POST_SUPPORT, postSupport)]);
}

function* postSupport(action) {
  yield request(
    action,
    "post",
    process.env.REACT_APP_SUPPORT_URL,
    "Message sent"
  );
}

function* request(action, method, url, successMessage) {
  const response = yield sendRequest(action, method, url, null, successMessage);
  return response.data;
}
